var map = {
	"./email.svg": "43be",
	"./gulp.svg": "dbad",
	"./linkedin.svg": "9ed9",
	"./pdf.svg": "5730",
	"./phone.svg": "c3bb",
	"./telegram.svg": "2b29",
	"./url.svg": "9a16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";